module.exports = __webpack_public_path__ + "media/images/stock_groups/efef-b3f3cafb05866972025f436f03b3a431.svg";